import React, { Suspense } from 'react';
import PropTypes from 'prop-types';
import ReactPlaceholder from 'react-placeholder';
import styled from '@emotion/styled';
import {
  InputPlaceholder,
  TextareaPlaceholder,
  Grid,
  FlexRow,
  FlexBaseCol
} from '@contently/toolkit';
import CustomFields from './customFields';
import HeadlineTextEditor from './HeadlineTextEditor';
import BodyTextEditor from './BodyTextEditor';
import { EditorContext } from '../../hooks/useEditorContext';
import { fieldType } from './customFields';


function StoryPlaceholder() {
  return (
    <React.Fragment>
      <ReactPlaceholder ready={false} rows={1}>
        <InputPlaceholder withLabel />
      </ReactPlaceholder>
      <ReactPlaceholder ready={false} rows={4}>
        <TextareaPlaceholder withLabel />
      </ReactPlaceholder>
    </React.Fragment>
  );
}

const StyledGrid = styled(Grid)`
  margin: 0px auto;
  padding: 0px 20px 44px 20px;
  max-width: 720px;
`;

export default function StoryContent({ storyId, historyMode, readOnlyMode, customFields }) {

  const editorContext = { historyMode, readOnlyMode };

  return (
    <EditorContext.Provider value={editorContext}>
      <StyledGrid>
        <Suspense fallback={<StoryPlaceholder />}>
          <FlexRow style={{margin: "16px 0 0 0"}}>
            <FlexBaseCol style={{marginBottom: 0}}>
              <HeadlineTextEditor
                storyId={storyId}
                historyMode={historyMode}
                readOnlyMode={readOnlyMode}
              />
            </FlexBaseCol>
          </FlexRow>
          <FlexRow style={{margin: "10px 0 16px 0"}}>
            <FlexBaseCol>
              <BodyTextEditor
                storyId={storyId}
                historyMode={historyMode}
                readOnlyMode={readOnlyMode}
              />
            </FlexBaseCol>
          </FlexRow>
        </Suspense>
      </StyledGrid>
      <CustomFields fields={customFields} />
    </EditorContext.Provider>
  );
}

StoryContent.defaultProps = {
  historyMode: false,
  readOnlyMode: false
};

StoryContent.propTypes = {
  storyId: PropTypes.number.isRequired,
  historyMode: PropTypes.bool,
  readOnlyMode: PropTypes.bool,
  customFields: PropTypes.arrayOf(fieldType)
};



// WEBPACK FOOTER //
// ./app/javascript/client/components/textEditor/StoryContent.jsx